import { useCallback } from "react";
import { useSearchParams } from "react-router-dom";

import { keepRelevantSearchParams } from "@/utils/utils";

const EMPTY_ADDITIONAL_KEYS: string[] = [];

export const useKeepRelevantParams = (additionalKeys: string[] = EMPTY_ADDITIONAL_KEYS) => {
  const [searchParams] = useSearchParams();
  const keepRelevantParams = useCallback(
    () => keepRelevantSearchParams(searchParams, additionalKeys),
    [additionalKeys, searchParams],
  );
  return keepRelevantParams;
};
